import './sass/main.scss'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import defaultState from "./store/defaultState";
import messages from '@/constants/translations'

import isBrowser from '@/helpers/isBrowser'

Vue.use(isBrowser)

import VueHead from 'vue-head'

Vue.use(VueHead)

import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing);

import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

import VueGtm from '@gtm-support/vue2-gtm'
import {LOCALE_EN, LOCALE_UA} from "@/constants/locales";

if (process.env.VUE_APP_GTM_ID) {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GTM_ID,
    defer: false,
    enabled: true,
    debug: false,
    loadScript: true,
  })
}

function json(url) {
  return fetch(url).then(res => res.json());
}


const createApp = (data) => {
  if (!localStorage.getItem('locale')) {
    if (/^ua\b/.test(navigator.language) || /^uk\b/.test(navigator.language) || /^ru\b/.test(navigator.language)) {
      locale = LOCALE_UA
      localStorage.setItem('locale', LOCALE_UA);
    } else {
      locale = LOCALE_EN
      localStorage.setItem('locale', LOCALE_EN);
    }
  } else {
    if (localStorage.getItem('locale') === LOCALE_UA) {
      locale = LOCALE_UA
    } else {
      locale = LOCALE_EN
    }
  }

  // if(data.ip) {
  //   if(data.country_code !== 'UA') {
  //     locale = 'en'
  //   }
  //   else {
  //     locale = 'ua'
  //   }
  // }
  // else {
  //   locale = 'en'
  // }

  Vue.config.productionTip = false

  const i18n = new VueI18n({
    locale: locale,
    messages
  })

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount('#app')

  if (store.state.stateKey < defaultState().stateKey) {
    Object.assign(store.state, defaultState());
  }
}

let locale = ''
let apiKey = 'ceb45948c1d2286d6844487bc44b3c7bba62a7376ada9e44cb2c57e1';

if (!store.state.ipData['ip']) {
  json(`https://api.ipdata.co?api-key=${apiKey}`).then(data => {
    // console.log('request')
    createApp(data)

    if (data.ip) {
      store.commit('setIpData', data)
    }
  });
} else {
  // console.log('from store')
  createApp(store.state.ipData)
}

